import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input, viewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatChipListbox, MatChipOption, MatChipSelectionChange } from '@angular/material/chips';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { MatDivider } from '@angular/material/list';
import { EnpsComponent } from '@common/components/base/enps-component';
import { SearchBoxComponent } from '@common/components/search-box/search-box';
import { GlobalTablesService } from '@common/services/global-tables-service';
import { LanguageSettings } from '@common/services/language-settings';
import { VisualStateService } from '@common/services/visual-state-service';
import { Store } from '@ngrx/store';
import { FilterTypes } from '@src/suite/common/enums/filter-types';
import { ViewStateService } from '@src/suite/common/services/view-state-service';
import { TeamMembersActions } from '@src/suite/common/store/team-members/team-members.actions';
import { selectSecurityRoles, selectTeamMembersSelectedRole, selectTeamMembersSelectedStatus, selectTeamMembersSelectedTeam } from '@src/suite/common/store/team-members/team-members.selectors';
import { AppService } from '@suite/app.service';
import { UsersResults } from '@suite/common/data-models/search-results/users-result';
import { NomWebServicesJson } from '@suite/common/services/nom-web-services-json';
import { TeamMembersService } from '@suite/common/services/team-members-service';

import { ClickStopPropagationDirective } from '../../../directives/stop-propagation';

@Component({
    selector: 'st-filter-manage-team-members',
    imports: [ClickStopPropagationDirective, FormsModule, MatAccordion, MatChipListbox, MatChipOption, MatDivider, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle],
    templateUrl: './filter-manage-team-members.html',
    styleUrl: './filter-manage-team-members.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: '.st-filter-manage-team-members',
    },
})
export class FilterManageTeamMembersComponent extends EnpsComponent {
    store = inject(Store);
    appService = inject(AppService);
    viewStateService = inject(ViewStateService);
    languageSettings = inject(LanguageSettings);
    nomWebServicesJson = inject(NomWebServicesJson);
    visualStateService = inject(VisualStateService);
    globalTablesService = inject(GlobalTablesService);
    teamMembersService = inject(TeamMembersService);
    protected changeDetectorRef = inject(ChangeDetectorRef);

    public filterMemberStatus: { StatusNumber: number; StatusName: string }[] = [
        { StatusNumber: 0, StatusName: 'Active' },
        { StatusNumber: 1, StatusName: 'Disabled' },
    ];

    readonly selectedTeam = this.store.selectSignal(selectTeamMembersSelectedTeam);
    readonly selectedRole = this.store.selectSignal(selectTeamMembersSelectedRole);
    readonly selectedStatus = this.store.selectSignal(selectTeamMembersSelectedStatus);
    readonly securityRoles = this.store.selectSignal(selectSecurityRoles);

    public staffIDs: string[] = [];

    public get groupByField(): string {
        return UsersResults.groupByField;
    }

    public get sortByField(): any {
        return UsersResults.sortByField;
    }
    public readonly searchBox = viewChild<SearchBoxComponent>('searchBox');
    public readonly type = input<number>();
    public filterTypes = FilterTypes;

    public async filterTeamMembers(event: MatChipSelectionChange, filter: ManageTeamMembersFilterKey) {
        const value = {
            [filter]: event.selected ? event.source.value : null,
        };
        this.store.dispatch(TeamMembersActions.filterTeamMembers(value));
    }
}
